import { useState, useEffect } from "react";
import { TermService } from "../services/termService";

export const useCurrentTermAndSession = () => {
  const [currentSession, setCurrentSession] = useState("");
  const [currentTerm, setCurrentTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const fetchTerm = async () => {
      try {
        const data = await TermService.getCurrentTerm();
        if (data && isMounted) {
          // Format session: "2025" -> "2025/2026"
          if (data.session) {
             if (!data.session.includes("/")) {
                 const startYear = parseInt(data.session, 10);
                 setCurrentSession(`${startYear}/${startYear + 1}`);
             } else {
                 setCurrentSession(data.session);
             }
          }
          if (data.term) {
             setCurrentTerm(data.term);
          } else if (data.name) {
             setCurrentTerm(data.name);
          }
        }
      } catch (error) {
        console.error("Failed to fetch current term", error);
      } finally {
        if (isMounted) setIsLoading(false);
      }
    };
    fetchTerm();
    
    return () => {
        isMounted = false;
    };
  }, []);

  return { currentSession, currentTerm, isLoading };
};
